export default "__VITE_ASSET__Cnxkwp6S__"